<template>
	<el-container style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
		<el-main>
			<div class="date_buttons" style="width: 100%;display: flex;flex-direction: row;margin-top: 30px;justify-content: flex-start;">
				<el-button size="mini" @click="selectDate(100)">重置</el-button>
				<el-button size="mini" @click="showCount">客服统计</el-button>
				<!-- <el-button size="mini" @click="showAdCount">推广账户</el-button> -->
				<el-select v-model="adUserId" placeholder="推广账户" style="margin-left: 20px;width: 6.25rem;" size="mini" @change="selectAdUser">
					<el-option v-for="(item , index) in adUserIdSel" :key="index"
					:label="item.adUserId"
					:value="item.value"
					></el-option>
				</el-select>
				<!-- <el-button size="mini" @click="selectDate(3)">三天</el-button>
				<el-button size="mini" @click="selectDate(7)">本周</el-button>
				<el-button size="mini"  @click="selectDate(30)">本月</el-button> -->
				<el-select v-model="queryTime" placeholder="选择天数" style="margin-left: 20px;width: 6.25rem;" size="mini" @change="selectDate">
					<el-option v-for="(item , index) in dateSel" :key="index"
					:label="item.queryTime"
					:value="item.value"
					></el-option>
				</el-select>
				<!-- <el-button size="mini"  @click="selectWX">转潜</el-button> -->
				<el-select v-model="isWX" placeholder="客户状态" size="mini" style="margin-left: 20px;width: 100px;" @change="selectIsWX">
					<el-option v-for="(item , index) in isWXsel" :key="index"
					:label="item.label"
					:value="item.value"
					></el-option>
				</el-select>
				<el-select v-model="isOverTime" placeholder="首句超时" size="mini" style="margin-left: 20px;width: 100px;" @change="selectIsOverTime">
					<el-option v-for="(item , index) in isOverTimeSel" :key="index"
					:label="item.label"
					:value="item.value"
					></el-option>
				</el-select>
				<el-select v-model="csId" placeholder="选择客服" size="mini" style="margin-left: 20px;width: 100px;" @change="selectCsId">
					<el-option v-for="(item , index) in csIdSel" :key="index"
					:label="item.realName"
					:value="item.id"
					></el-option>
				</el-select>
				<el-select v-model="region" placeholder="地区" size="mini" style="margin-left: 20px;width: 100px;" @change="selectRegion">
					<el-option v-for="(item , index) in regionSel" :key="index"
					:label="item.region"
					:value="item.value"
					></el-option>
				</el-select>
				<div class="block" style="margin-left: 20px;">
					<el-date-picker 
					v-model="dateValue" 
					type="datetimerange" 
					align="right" 
					unlink-panels 
					range-separator="至" 
					start-placeholder="开始日期" 
					end-placeholder="结束日期"
					value-format="timestamp"
					size="mini"
					@change="selectDate(999)">
					</el-date-picker>
				</div>
				<el-button size="mini" type="primary" @click="exportToExcel(1)" style="margin-left: 10px;">导出报表</el-button>
			</div>
			<div class="count">
				<div class="count1"><span class="count_span1">浏览数：</span><span class="count_span">{{llcount}}</span></div>
				<div class="count2"><span class="count_span1">对话数：</span><span class="count_span">{{ddcount}}</span></div>
				<div class="count2"><span class="count_span1">转潜数：</span><span class="count_span">{{wxcount}}</span></div>
				<div class="count2"><span class="count_span1">对话率：</span><span class="count_span">{{diaRate}}</span></div>
				<div class="count2"><span class="count_span1">转潜率：</span><span class="count_span">{{wxRate}}</span></div>
			</div>
			<div class="table_page" style="display: flex;flex-direction: column;justify-content: flex-start;">
				<el-table style="margin-top: 10px;width: 100%;"
					max-height="500"
					:data="tableData" 
					border 
					highlight-current-row 
					:header-cell-style="headerStyle" 
					:cell-style="cellStyle">
						<el-table-column type="expand" width="55">
							<template slot-scope="props">
								<el-form label-position="left" inline class="demo-table-expand">
									<el-form-item label="用户IP地址">
										<span>{{ props.row.cIP }}</span>
									</el-form-item>
									<el-form-item label="设备详情">
										<span>{{ props.row.cOS }}</span>
									</el-form-item>
									<el-form-item label="搜索问句">
										<span>{{ props.row.query }}</span>
									</el-form-item>
								</el-form>
							</template>
						</el-table-column>
						<el-table-column property="createTime" label="开始时间" width="110">
						</el-table-column>
						<el-table-column  label="用户标签" width="60">
							<template slot-scope="scope">
								<!-- <div class="tag_label" slot="reference" :style="{color:'#'+scope.row.labelColor}">{{scope.row.labelName}}</div> -->
								<div class="tag_label" slot="reference" v-for="(item , index) in scope.row.cLabel" :key="index" :style="{color:'#'+item.color}">{{scope.row.cLabel.length!=[]?item.name:'暂无'}}</div>
							</template>
						</el-table-column>
						<el-table-column property="cNickName" label="用户昵称" width="120">
						</el-table-column>
						<el-table-column property="csRealName" width="100" label="分配坐席">
						</el-table-column>
						<el-table-column property="cMessageCount" width="60" label="客户发言">
						</el-table-column>
						<el-table-column property="csMessageCount" width="60" label="坐席发言">
						</el-table-column>
						<el-table-column property="firstTimeSecond" width="60" label="首句时长">
						</el-table-column>
						<el-table-column width="60" label="是否超时">
							<template slot-scope="scope">
								<div class="tag_label" slot="reference" :style="{color:(scope.row.isFirstOvertime=='是'?'red':'')}">{{scope.row.isFirstOvertime}}</div>
							</template>
						</el-table-column>
						<el-table-column property="firstOvertime" width="60" label="首句超时">
						</el-table-column>
						<el-table-column property="cRegion" width="60" label="城市">
						</el-table-column>
						<el-table-column property="keyword" label="关键词" width="120">
						</el-table-column>
						<el-table-column property="lengthTimeMin" width="60" label="入话时长">
						</el-table-column>
						<el-table-column property="lengthTimeOver" width="60" label="入话超时">
						</el-table-column>
						<el-table-column property="cSource" width="60" label="客户来源">
						</el-table-column>
						<el-table-column property="wxcount" width="60" label="是否转潜">
						</el-table-column>
						<el-table-column  label="对话记录" width="120">
							<template slot-scope="scope">
								<el-button type="text" size="mini" @click="clickCell(scope.row)">对话记录</el-button>
							</template>
						</el-table-column>
					</el-table>
			</div>
			<div style="width: 100%;display: flex;justify-content: center;">
				<el-pagination style="margin-top: 30px;" background :pager-count='9' :page-size="100" layout="prev, pager, next, total" :total="total"
				@prev-click="pre" @next-click="next" @current-change="handleCurrentChange" :current-page.sync="currentPage"></el-pagination>
			</div>
		</el-main>	
		
		<chat-detail :isShow="showDetail" @closeDial="closeDialAction" :item="cellItem" @updateNickname="updateNickname"></chat-detail>
		<div class="csCount" v-show="showCsCount">
			<el-dialog title="客服统计表" width="50%" lock-scroll :visible.sync="showCsCount" :close-on-click-modal="false" center>
				<el-table
				:data="csCountData" 
				border
				max-height="500"
				highlight-current-row 
				:header-cell-style="headerStyle" 
				:cell-style="cellStyle">
					<el-table-column property="redlName" label="坐席名称">
					</el-table-column>
					<el-table-column property="dhs" label="对话数">
					</el-table-column>
					<el-table-column property="firstTimeSecond" label="首句时长">
					</el-table-column>
					<el-table-column property="firstTimeSecondCount" label="超时">
					</el-table-column>
					<el-table-column property="firstTimeOver" label="超时率">
					</el-table-column>
					<el-table-column property="wx" label="微信">
					</el-table-column>
					<el-table-column property="wxRate" label="转微率">
					</el-table-column>
					<el-table-column property="dh" label="电话">
					</el-table-column>
					<el-table-column property="dhRate" label="转电率">
					</el-table-column>
					<el-table-column property="qq" label="QQ">
					</el-table-column>
					<el-table-column property="QQRate" label="转Q率">
					</el-table-column>
				</el-table>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" size="small" @click="exportToExcel(2)">导出统计</el-button>
				</div>
			</el-dialog>
		</div>

	</el-container>
</template>

<script>
	import chatDetail from './chatDetail.vue'
	
	export default {
		name: 'chatReport',
		data() {
			return {
				dateValue: [],
				tableData:[],
				page:1,
				total:0,
				allSelData:{
					depId:"",
					csid:"",
					queryTime:1,
					page:1,
					size:100,
					source:"",
					startTime:"",
					endTime:"",
					lableId:"1",
					isTime:"",
					region:"",
					type:1,
					adUserId:""
				},
				
				//历史消息测试
				showDetail:false,
				cellItem:null,
				ddcount:0,
				llcount:0,
				wxcount:0,
				diaRate:0,
				wxRate:0,
				isWX:"已开口",
				isOverTime:"",
				isWXsel:[
					{
						value:"0",
						label:"全部"
					},
					{
						value:"1",
						label:"已开口"
					},
					{
						value:"2",
						label:"未开口"
					},
				],
				isOverTimeSel:[
					{
						value:"不传",
						label:"全部"
					},
					{
						value:1,
						label:"超时"
					},
					{
						value:2,
						label:"未超时"
					}
				],
				selectForm:{
					type:1
				},
				csIdSel:[{
					realName:"全部",
					value:"不传"
				}],
				regionSel:[
					{
						region:"全部",
						value:"不传"
					}
				],
				dateSel:[
					{
						queryTime:"当天",
						value:1
					},
					{
						queryTime:"三天",
						value:3
					},
					{
						queryTime:"本周",
						value:7
					},
					{
						queryTime:"本月",
						value:30
					}
				],
				adUserIdSel:[
					{
						adUserId:"全部",
						value:"不传"
					}
				],
				region:"",
				csId:"",
				currentPage:1,
				queryTime:"",
				showCsCount:false,
				csCountData:[],
				adUserId:""
			}
		},
		
		components:{chatDetail},
		
		mounted() {
			console.log(this.util.getLocalAccount())
			this.statisticsAll()
			this.listMapSel()
			this.selectByDepId()
			this.selectRegionList()
			this.selectSysTag()
			this.selectAduseridList()
		},
		methods: {
			selectDate(value){
				// console.log("日期数据",this.dateValue)
				if(value === 100){
						this.allSelData = {
						depId:"",
						csid:"",
						queryTime:1,
						page:1,
						size:100,
						source:"",
						startTime:"",
						endTime:"",
						lableId:"1",
						isTime:"",
						region:"",
						type:1,
						adUserId:""
					}
					this.isWX="已开口"
					this.isOverTime=""
					this.csId=""
					this.region=""
					this.dateValue=[]
					this.queryTime=""
					this.adUserId=""
				}else if(value === 999){
					this.allSelData.queryTime=""
					this.allSelData.startTime = this.util.timeStampToDate(this.dateValue[0],0)
					this.allSelData.endTime = this.util.timeStampToDate(this.dateValue[1],0)
				}else{
					this.allSelData.startTime=""
					this.allSelData.endTime=""
					this.allSelData.queryTime=this.queryTime
				}
				this.handleCurrentChange(1)
			},
			// selectDates(){
			// 	if(this.dateValue==null){
			// 		this.allSelData.startTime=""
			// 		this.allSelData.endTime=""
			// 	}else{
			// 		this.allSelData.queryTime=""
			// 		this.allSelData.startTime = this.util.timeStampToDate(this.dateValue[0],0)
			// 		this.allSelData.endTime = this.util.timeStampToDate(this.dateValue[1],0)
			// 	}
			// 	this.handleCurrentChange(1)
			// },
			selectIsWX(value){
				console.log(value)
				this.allSelData.lableId = this.isWX
				this.handleCurrentChange(1)
			},
			selectIsOverTime(){
				this.allSelData.isTime=this.isOverTime
				this.handleCurrentChange(1)
			},
			selectCsId(){
				console.log("selectCsId = ")
				this.allSelData.csid = this.csId
				this.handleCurrentChange(1)
			},
			selectRegion(){
				console.log("selectRegion = ")
				this.allSelData.region = this.region
				this.handleCurrentChange(1)
			},
			selectAdUser(){
				console.log("selectAdUser = " )
				this.allSelData.adUserId = this.adUserId
				this.handleCurrentChange(1)
			},
			async selectSysTag(){
				var api = "/manager/label/selectSystemLabelList"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:{}
				})
				console.log("系统标签========",response)
				for(let i=0; i<response.data.length; i++){
					this.isWXsel.push({
						value:response.data[i].id,
						label:response.data[i].name
					})
				}
			},
			headerStyle({rowIndex}) {
				if(rowIndex===0){
					return 'text-align:left;padding:5px;color:#000000;'
				}else{
					return 'text-align:left;padding:5px;'
				}
			},
			cellStyle() {
				return 'text-align:left;padding:5px;'
			},
			
			// 报表数据查询
			async statisticsAll(){
				for(var key in this.allSelData){
					if(this.allSelData[key]!="" && this.allSelData[key]!="不传"){
						this.selectForm[key]=this.allSelData[key]
					}
				}
				console.log("this.selectForm=",this.selectForm)
			
				var api = "/manager/chatHistory/selectChatHistoryAll"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:this.selectForm,
				})
				console.log("报表数据",response)
				this.tableData=response.data.list
				
				if(this.tableData!=undefined){
					this.total=response.data.total
					for(var i = 0; i < this.tableData.length; i++){
						this.tableData[i].createTime = this.util.timeStampToDate(this.tableData[i].createTime*1000 , 0)
						this.tableData[i].cSource = this.tableData[i].cSource=="1"?"百度":""
						this.tableData[i].firstOvertime = this.tableData[i].firstTimeSecond>10?this.tableData[i].firstTimeSecond-10:0
						this.tableData[i].isFirstOvertime = this.tableData[i].firstOvertime>0?"是":"否"
						this.tableData[i].lengthTimeOver = this.tableData[i].lengthTimeMin > 10?this.tableData[i].lengthTimeMin- 10:0
					}
				}else{
					this.total=0
				}
				
				this.selectForm = {}
			},
			async listMapSel(){
				for(var key in this.allSelData){
					if(this.allSelData[key]!="" && this.allSelData[key]!="不传"){
						this.selectForm[key]=this.allSelData[key]
					}
				}
				
				var api = "/manager/chatHistory/listMap"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:this.selectForm,
				})
				console.log("报表数据",response.data)
				this.ddcount = response.data.ddcount
				
				this.llcount = response.data.llcount
				this.wxcount = response.data.wxcount
				this.diaRate = this.llcount!=0?Number(this.ddcount/this.llcount*100).toFixed(2)+"%":"0%"
				this.wxRate = this.ddcount!=0?Number(this.wxcount/this.ddcount*100).toFixed(2)+"%":"0%"
				// this.tableData=response.data.list
				this.selectForm = {}
			}
			,
			// 分页器相关方法
			pre(info) {
				console.log("pre：", info)
				this.allSelData.page = info
				this.currentPage = info
				this.statisticsAll()
				this.listMapSel()
				this.selectByDepId()
				this.selectRegionList()
			},
			next(info) {
				this.currentPage = info
				console.log("next：", info)
				this.allSelData.page = info
				this.statisticsAll()
				this.listMapSel()
				this.selectByDepId()
				this.selectRegionList()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.start = 4 * (val - 1)
				this.allSelData.page = val
				console.log("当前页码：", val, this.start)
				this.statisticsAll()
				this.listMapSel()
				this.selectByDepId()
				this.selectRegionList()
			},
			
			clickCell(row) {
				// console.log('chatReport clickCell row = ', row)
				// console.log('chatReport clickCell event = ', event)
				this.showDetail = true 
				this.cellItem = row
				console.log("这条数据",this.cellItem)
			},
			
			closeDialAction() {
				console.log('logging closeDialAction')
				this.showDetail = false
				this.cellItem = null
				this.statisticsAll()
			},
			
			async exportToExcel(i){
				for(var key in this.allSelData){
					if(this.allSelData[key]!="" && this.allSelData[key]!="不传"){
						this.selectForm[key]=this.allSelData[key]
					}
				}
				var api = i==1?"/manager/chatHistory/exportToExcel":"/manager/chatHistory/exportCsStatisExcel"
				this.selectForm.page = 1
				this.selectForm.size = 10000
				let params = this.selectForm
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:params,
					responseType:"arraybuffer"
				})
				console.log(response)
				let blob = new Blob([response],{type:"application/vnd.ms-excel"})
				let fileName = i==1?"报表":"客服统计" + this.util.getFormatDate(3) + ".xls"
				this.downFile(blob, fileName)
				this.selectForm = {}
			},
			downFile(blob, fileName){
				if (window.navigator.msSaveOrOpenBlob) {
					navigator.msSaveBlob(blob, fileName);
					} else {
						var link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.download = fileName;
						link.click();
						window.URL.revokeObjectURL(link.href);
				}
			},
			async selectByDepId(){
				var api = "/manager/user/selectAllByDepId"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:{
						depId:this.util.getLocalAccount().depId
					},
				})
				this.csIdSel = [{
						realName:"全部",
						value:"不传"
					}].concat(response.data) 
				// console.log("部门客服数据selectByDepId=",this.csIdSel)
			},
			async selectRegionList(){
				var api = "/manager/chatHistory/selectRegionList"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:{
					},
				})
				console.log("地区列表",response.data)
				let regionList = []
				for(var i=0 ; i<response.data.length; i++){
					regionList.push({
						region:response.data[i].region,
						value:response.data[i].region
					})
				}
				this.regionSel = [{
							region:"全部",
							value:"不传"
						}].concat(regionList)
				console.log("地区列表",this.regionSel)
			},
			showCount(){
				this.showCsCount = true
				this.selectByUser()
			},
			async selectAduseridList(){
				console.log("showAdcount")
				let data ={}
				if (this.allSelData.queryTime==""){
					data={
						depId:this.util.getLocalAccount().depId,
						startTime:this.allSelData.startTime,
						endTime:this.allSelData.endTime
					}
				}else{
					data = {
						depId:this.util.getLocalAccount().depId,
						queryTime:this.allSelData.queryTime
					}
				}
				var api = "/manager/chatHistory/selectAduseridList"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:data
				})
				
				let adUserIdList = []
				for(var i=0 ; i<response.data.length; i++){
					adUserIdList.push({
						adUserId:response.data[i].adUserId,
						value:response.data[i].adUserId
					})
				}
				this.adUserIdSel = [{
							adUserId:"全部",
							value:"不传"
						}].concat(adUserIdList)
				console.log("推广账户",this.adUserIdSel)
				
			},
			// 查询客服统计表
			async selectByUser(){
				// for(var key in this.allSelData){
				// 	if(this.allSelData[key]!="" && this.allSelData[key]!="不传"){
				// 		this.selectForm[key]=this.allSelData[key]
				// 	}
				// }
				let data ={}
				if (this.allSelData.queryTime==""){
					data={
						depId:this.util.getLocalAccount().depId,
						startTime:this.allSelData.startTime,
						endTime:this.allSelData.endTime
					}
				}else{
					data = {
						depId:this.util.getLocalAccount().depId,
						queryTime:this.allSelData.queryTime
					}
				}
				var api = "/manager/chatHistory/selectByUser"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:data
				})
				this.csCountData = response.data
				if(this.csCountData!=null){
					for(let i=0; i<this.csCountData.length; i++){
						this.csCountData[i].firstTimeOver = this.csCountData[i].dhs!=0||this.csCountData[i].firstTimeSecondCount?Number(this.csCountData[i].firstTimeSecondCount/this.csCountData[i].dhs*100).toFixed(2)+"%":"0.00%"
						this.csCountData[i].wxRate = this.csCountData[i].dhs!=0||this.csCountData[i].wx?Number(this.csCountData[i].wx/this.csCountData[i].dhs*100).toFixed(2)+"%":"0.00%"
						this.csCountData[i].dhRate = this.csCountData[i].dhs!=0||this.csCountData[i].dh?Number(this.csCountData[i].dh/this.csCountData[i].dhs*100).toFixed(2)+"%":"0.00%",
						this.csCountData[i].QQRate = this.csCountData[i].dhs!=0||this.csCountData[i].qq?Number(this.csCountData[i].qq/this.csCountData[i].dhs*100).toFixed(2)+"%":"0.00%"
					}
				}
			
				// this.selectForm = {}
			},
			updateNickname() {
				this.statisticsAll()
			},
			
		}
	}
</script>


<style scoped>
	.demo-table-expand {
		font-size: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}
	.demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}
	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
	
	.count{
		height: auto;
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		/* align-items: center; */
		margin-top: 20px;
	}	
	
	.count1{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		/* height: 30px; */
		text-align: center;
	}
	
	.count2{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		/* height: 30px; */
		text-align: center;
		margin-left: 10px;
	}
	
	.count_span{
		/* height: 100%;	 */
		display: inline-block;
		vertical-align: middle;
		color: #409EFF;
		margin: 0 auto;
		line-height: 20px;
	}
	
	.count_span1{
		/* height: 100%; */
		display: inline-block;
		vertical-align: middle;
		/* color: #409EFF; */
		margin: 0 auto;
		line-height: 20px;
	}

</style>
